import React from 'react';

export function Dashboard() {
  return (
    <div className="grow px-3 flex flex-col gap-8">



      {/* Hero Banner */}
      {/* <div className="relative w-full min-h-[350px] rounded-lg overflow-hidden flex items-center bg-vstargray-100">
        <img
          src="/assets/images/loginbg01.jpg"
          alt="Hero Banner"
          className="absolute inset-0 w-full h-full object-cover object-center z-0"
        />
        <div className="relative z-10 p-8 max-w-xl">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">THE PERFECT INNERGEAR<br />FOR EVERYDAY ATHLETES</h1>
          <p className="text-lg text-white mb-4">Discover comfort, style, and performance for your daily routine.</p>
          <div className="text-4xl font-extrabold text-white tracking-widest">Zoiro</div>
        </div>
      </div> */}
      {/* Info/Expert Section */}
      <div className="flex flex-col md:flex-row gap-6 items-center bg-vstargray-100 rounded-lg">
        <img src="https://www.sporto.in/cdn/shop/files/Banner_13_Wow_Bermudas_Desktop_1800x740.jpg?v=1744041692" alt="Expert Care" className="w-full h-84 object-cover rounded-lg shadow" />
        {/* <div>
          <h3 className="text-2xl font-bold mb-2 text-vstargray-700">Expert Care for Employees</h3>
          <p className="mb-2 text-vstargray-500">Our in-house experts have designed innerwear that accentuates your comfort while giving it all the care it needs. Go ahead, give yourself the best!</p>
          <a href="#" className="text-blue-600 font-semibold hover:underline">Explore Now</a>
        </div> */}
      </div>
      {/* Product/News Highlight */}
      <div className="flex flex-col md:flex-row gap-6 items-center">
        <img src="/assets/temp/dashboard/innerware-demo.png" alt="New Arrival" className="w-full md:w-1/2 h-64 object-cover rounded-lg shadow" />
        <div className="flex-1">
          <h3 className="text-xl font-bold mb-2 text-vstargray-700">New Arrival: Nomad X Sunglasses</h3>
          <p className="mb-2 text-vstargray-500">Rs. 1,999 | View Details</p>
          <p className="text-vstargray-600">Experience the latest in comfort and style with our new arrivals. Perfect for every occasion and designed for supreme comfort.</p>
        </div>
      </div>

      {/* Shop by Collection */}
      <div>
        <h2 className="text-xl font-bold mb-4 text-vstargray-700">Shop by Collection</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="rounded-lg overflow-hidden bg-white shadow flex flex-col items-center p-3">
            <img src="/assets/temp/dashboard/modal-soft.png" alt="Modal Softs" className="w-full h-40 object-cover mb-2" />
            <span className="font-semibold">Modal Softs</span>
          </div>
          <div className="rounded-lg overflow-hidden bg-white shadow flex flex-col items-center p-3">
            <img src="/assets/temp/dashboard/trends.png" alt="Trends" className="w-full h-40 object-cover mb-2" />
            <span className="font-semibold">Trends</span>
          </div>
          <div className="rounded-lg overflow-hidden bg-white shadow flex flex-col items-center p-3">
            <img src="/assets/temp/dashboard/sport.png" alt="Sports" className="w-full h-40 object-cover mb-2" />
            <span className="font-semibold">Sports</span>
          </div>
          <div className="rounded-lg overflow-hidden bg-white shadow flex flex-col items-center p-3">
            <img src="/assets/temp/dashboard/softclassic.png" alt="Soft Classics" className="w-full h-40 object-cover mb-2" />
            <span className="font-semibold">Soft Classics</span>
          </div>
        </div>
      </div>

      {/* Highlight/Feature Section */}
      <div className="rounded-lg bg-yellow-200 p-8 flex flex-col md:flex-row items-center gap-8">
        <img src="/assets/images/imagebglogin.jpg" alt="Trendy" className="w-40 h-40 object-cover rounded-lg shadow" />
        <div>
          <h3 className="text-2xl font-bold mb-2 text-yellow-900">Trendiest Innerwear Around</h3>
          <p className="mb-4 text-yellow-900">The unique patterns and designs inspired by the latest trends are what sets Zoiro Trends apart.</p>
          <div className="flex flex-wrap gap-4 text-yellow-900">
            <span className="font-semibold flex items-center gap-2">🌟 Skin Sense Technology</span>
            <span className="font-semibold flex items-center gap-2">❄️ Instacool Design</span>
            <span className="font-semibold flex items-center gap-2">🧵 Fab Fit</span>
            <span className="font-semibold flex items-center gap-2">🛏️ Supremely Soft</span>
          </div>
        </div>
      </div>

      <div className='min-h-9'></div>

    </div>
  );
}
